import { Box } from '@chakra-ui/react';
import DebouncedInput from 'src/components/DebouncedInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Range(_ref) {
  var _columnFilterValue$, _columnFilterValue$2;

  var column = _ref.column,
      isDisabled = _ref.isDisabled;
  var columnFilterValue = column.getFilterValue();
  var min = (_columnFilterValue$ = columnFilterValue === null || columnFilterValue === void 0 ? void 0 : columnFilterValue[0]) !== null && _columnFilterValue$ !== void 0 ? _columnFilterValue$ : '';
  var max = (_columnFilterValue$2 = columnFilterValue === null || columnFilterValue === void 0 ? void 0 : columnFilterValue[1]) !== null && _columnFilterValue$2 !== void 0 ? _columnFilterValue$2 : '';
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    columnGap: 2,
    e2eid: "Filter_Range_Box",
    children: [/*#__PURE__*/_jsx(DebouncedInput, {
      bg: "white",
      type: "number",
      placeholder: "\u2265",
      px: 2,
      value: min,
      onChange: function onChange(value) {
        return column.setFilterValue(function (old) {
          return [value, old === null || old === void 0 ? void 0 : old[1]];
        });
      },
      isDisabled: isDisabled,
      e2eid: "Filter_Range_DebouncedInput"
    }), /*#__PURE__*/_jsx(DebouncedInput, {
      bg: "white",
      type: "number",
      placeholder: "\u2264",
      px: 2,
      value: max,
      onChange: function onChange(value) {
        return column.setFilterValue(function (old) {
          return [old === null || old === void 0 ? void 0 : old[0], value];
        });
      },
      isDisabled: isDisabled,
      e2eid: "Filter_Range_DebouncedInput_2"
    })]
  });
}